import { Text, View, StyleSheet } from '@react-pdf/renderer';

interface TableRow {
  unitTitle: string;
  result: string;
  year: string;
}

const styles = StyleSheet.create({
  table: {
    display: 'flex',
    width: '100%',
    marginTop: 16,
    marginBottom: 0,
    fontSize: 10,
    flexGrow: 1,
    flexBasis: 0,
  },
  row: { flexDirection: 'row', flexWrap: 'nowrap', marginTop: '2px' },
  cell: {
    padding: 2,
    flex: 1,
    textAlign: 'left',
    flexShrink: 1,
    flexGrow: 0,
    whiteSpace: 'nowrap',
    minWidth: '80px',
  },
  titleCell: { padding: 2, flex: 1, textAlign: 'left', flexGrow: 1, flexBasis: 0 },
  header: { borderBottomWidth: 2, borderBottomColor: '#cfced0' },
});

function Table({ data }: { data?: TableRow[] }): React.ReactElement {
  return (
    <View style={styles.table}>
      <View style={[styles.row, styles.header]}>
        <Text style={styles.titleCell}>Unit title</Text>
        <Text style={styles.cell}>Result</Text>
        <Text style={[styles.cell, { textAlign: 'center' }]}>Year</Text>
      </View>
      {data?.map((row) => (
        <View style={styles.row} key={row.unitTitle}>
          <Text style={styles.titleCell}>{row.unitTitle}</Text>
          <Text style={styles.cell}>{row.result}</Text>
          <Text style={[styles.cell, { textAlign: 'center' }]}>{row.year}</Text>
        </View>
      ))}
    </View>
  );
}

export default Table;
